import type { ReactNode } from 'react'
import './Band.css'

export interface BandProps {
  imageSrc?: string
  imageAlt?: string
  /**
   * Visuel composé par l'appelant, prioritaire sur `imageSrc` — c'est par là
   * que passe un `MediaImage` piloté par le back-office, qui porte son propre
   * `srcset`, son point focal et son signalement d'origine.
   */
  image?: ReactNode
  imagePlaceholder?: ReactNode
  tag: ReactNode
  reverse?: boolean
  children: ReactNode
}

export function Band({ imageSrc, imageAlt, image, imagePlaceholder, tag, reverse = false, children }: BandProps) {
  const classes = ['azoya-band', reverse ? 'azoya-band--reverse' : ''].filter(Boolean).join(' ')
  return (
    <div className={classes}>
      <div className="azoya-band-image">
        {image ?? (imageSrc ? <img src={imageSrc} alt={imageAlt} /> : imagePlaceholder)}
      </div>
      <div className="azoya-band-content">
        {tag}
        <p className="azoya-band-text">{children}</p>
      </div>
    </div>
  )
}
